import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import type { Api } from "@/api/types";
import { getConfigSnapshot } from "@/helpers/config";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { QUERY_KEYS } from "@/query-keys";

/** Query options for an API client, so router loaders can prefetch the same cache entries outside React. */
export const configurationQueries = (api: Api<null>["api"]) => {
  return {
    listAppBrandings: () =>
      queryOptions({
        queryKey: QUERY_KEYS.CONFIGURATIONS_APP_BRANDING_LIST(),
        queryFn: api.getConfigurationBrandsV1,
        select: commonAPIDataSelector,
        staleTime: Infinity,
        gcTime: Infinity,
      }),
  };
};

export const useConfigurationQueries = () => configurationQueries(useApi());

/** The SDK owns retries and its cache policy; Query shares the loaded snapshot across app consumers. */
export function applicationConfigQueryOptions() {
  return queryOptions({
    queryKey: ["application-config"],
    queryFn: getConfigSnapshot,
    staleTime: Infinity,
    retry: false,
  });
}
